/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-props-no-spreading */
import UnifiedLayout from 'pages/_layouts/UnifiedLayout';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { toast } from 'react-toastify';
import { selectDoctor, selectFunc, selectPatient } from 'redux/features/auth/authSlice';
import { getPermissionDeniedMessage, hasPermission } from 'utils/permissions';

/**
 * RouteWrapper com proteção baseada em role
 * @param {boolean} isPrivate - Se a rota requer autenticação
 * @param {string | string[] | null} requiredRole - Role(s) necessário(s): 'doctor', 'patient', 'funcionario', array, ou null
 */
export default function RouteWrapper({
  component: Component,
  isPrivate = false,
  requiredRole = null,
  requiredPermission = null,
  disableLayout = false,
  allowAuthenticatedPublic = false,
  ...rest
}) {
  const patient = useSelector(selectPatient);
  const doctor = useSelector(selectDoctor);
  const func = useSelector(selectFunc);

  // Converter requiredRole para array
  const allowedRoles = Array.isArray(requiredRole)
    ? requiredRole
    : requiredRole
      ? [requiredRole]
      : null;

  // Se rota é privada mas usuário não está autenticado
  if (isPrivate && !patient && !doctor && !func) return <Redirect to="/" />;

  // Se houver roles específicos requeridos, verificar se o usuário tem um deles
  if (allowedRoles) {
    const hasRequiredRole =
      (allowedRoles.includes('doctor') && doctor) ||
      (allowedRoles.includes('patient') && patient) ||
      (allowedRoles.includes('funcionario') && func);

    if (!hasRequiredRole) {
      if (doctor) return <Redirect to="/agenda" />;
      if (patient) return <Redirect to="/dashboardpac" />;
      if (func) return <Redirect to="/agenda" />;
      return <Redirect to="/" />;
    }
  }

  if (requiredPermission) {
    const isAllowed = hasPermission({ doctor, func, patient, permission: requiredPermission });

    if (!isAllowed) {
      const toastId = `permission-denied-${requiredPermission}`;
      if (!toast.isActive(toastId)) {
        toast.warn(getPermissionDeniedMessage(requiredPermission), { toastId });
      }

      if (doctor || func) return <Redirect to="/agenda" />;
      if (patient) return <Redirect to="/dashboardpac" />;
      return <Redirect to="/" />;
    }
  }

  // Redirecionar usuários autenticados que tentam acessar rotas públicas
  if (
    !allowAuthenticatedPublic &&
    (doctor || func) &&
    !isPrivate &&
    !allowedRoles?.includes('patient')
  )
    return <Redirect to="/agenda" />;

  if (!allowAuthenticatedPublic && patient && !isPrivate && !allowedRoles?.includes('doctor'))
    return <Redirect to="/dashboardpac" />;

  return (
    <Route
      {...rest}
      render={(routeProps) =>
        disableLayout ? (
          <Component {...routeProps} />
        ) : (
          <UnifiedLayout>
            <Component {...routeProps} />
          </UnifiedLayout>
        )
      }
    />
  );
}
